import styled from 'styled-components'

export const EmptyStateText = styled.p`
	font-weight: 400;
	margin-bottom: 16px;
`
